function scaleValueUndefined(scale) {
  // undefined, null or -1 usually when undefined
  return typeof scale !== 'number' || scale < 0;
}

// assumes scales go from big to small as they do on mapmodule
function getZoomLevel(scale, scaleArray, defaultValue) {
  if (typeof scale !== 'number' || scale < 0) {
    return defaultValue;
  }
  var index = scaleArray.findIndex(function (s) {
    return scale >= s;
  });
  if (index === -1) {
    return defaultValue;
  }
  return index;
}
;
export var getZoomLevelHelper = function getZoomLevelHelper(mapScales) {
  if (!mapScales || !Array.isArray(mapScales)) {
    throw new TypeError('Expects scales array as param');
  }
  var scaleArray = mapScales.slice(0);
  var getZoom = function getZoom(scale) {
    return getZoomLevel(scale, scaleArray, -1);
  };
  return {
    getMinZoom: function getMinZoom(minScale) {
      return getZoom(minScale);
    },
    getMaxZoom: function getMaxZoom(maxScale) {
      return getZoom(maxScale);
    },
    setOLZoomLimits: function setOLZoomLimits(olLayer, minScale, maxScale) {
      var min = getZoom(minScale);
      if (min < 1) {
        olLayer.setMinZoom(-Infinity);
      } else {
        // OL: The minimum view zoom level (exclusive) above which this layer will be visible.
        // -1 for min because of exclusivity
        olLayer.setMinZoom(min - 1);
      }
      var max = getZoom(maxScale);
      if (max < 0 || max >= scaleArray.length) {
        olLayer.setMaxZoom(Infinity);
      } else {
        // OL: The maximum view zoom level (inclusive) at which this layer will be visible.
        olLayer.setMaxZoom(max);
      }
    }
  };
};
export var isInScale = function isInScale(currentScale, minScale, maxScale) {
  var maxOk = scaleValueUndefined(maxScale) || currentScale >= maxScale;
  var minOk = scaleValueUndefined(minScale) || currentScale <= minScale;
  // scale undefined or between min & max
  return maxOk && minOk;
};

/**
 * Parses minScale, maxScale, minResolution, maxResolution, minZoomLevel, maxZoomLevel from options
 * and returns an object with min and max keys having values of minScale and maxScale regardless of the input type
 *
 * - minScale, minZoom, maxResolution: how close _do you need to_ zoom to see the layer
 * - maxScale, maxZoom, minResolution: how close _can_ you zoom to _still_ see the layer
 */
export var getScalesFromOptions = function getScalesFromOptions() {
  var scales = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var resolutions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var result = {
    // minScale == how close _do you need to_ zoom to see the layer
    min: options.minScale || -1,
    // maxScale == how close _can_ you zoom to _still_ see the layer
    max: options.maxScale || -1
  };
  var zoomHelper = getZoomLevelHelper(resolutions);
  var maxAllowedZoom = scales.length - 1;
  if (typeof options.minResolution === 'number') {
    // how close _can_ you zoom to _still_ see the layer
    var _maxZoom = zoomHelper.getMaxZoom(options.minResolution);
    if (isBetween(_maxZoom, 0, maxAllowedZoom)) {
      result.max = scales[_maxZoom];
    }
  }
  if (typeof options.maxResolution === 'number') {
    // how close _do you need to_ zoom to see the layer
    var _minZoom = zoomHelper.getMinZoom(options.maxResolution);
    if (isBetween(_minZoom, 0, maxAllowedZoom)) {
      result.min = scales[_minZoom];
    }
  }
  var minZoom = options.minZoomLevel;
  if (isBetween(minZoom, 0, maxAllowedZoom)) {
    // how close _do you need to_ zoom to see the layer
    result.min = scales[minZoom];
  }
  var maxZoom = options.maxZoomLevel;
  if (isBetween(maxZoom, 0, maxAllowedZoom)) {
    // how close _can_ you zoom to _still_ see the layer
    result.max = scales[maxZoom];
  }
  return result;
};

// only set limits if they actually limit visibility (between 1 and max-1)
function isBetween(num, min, max) {
  if (typeof num !== 'number') {
    return false;
  }
  return num > min && num < max;
}
;